import React from "react";
import "./terms.css"
import {Button, Col, Form, Input, Row, Space} from "antd";

class About extends React.Component {

    render() {

        return (
            <div>
                <div className="main-background">
                    <div className="uk-container uk-container-small">
                        <Row>
                            <Col span={12}>
                                <div className="uk-margin-large-top uk-padding  uk-padding-remove-horizontal">
                                    <h1 className="uk-h1 uk-text-bold">
                                        Our story
                                    </h1>
                                    <h1 className="uk-h3">
                                        Inspiring collaboration and creativity with Apple products.
                                    </h1>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>

                <section className="uk-margin-large uk-container">
                    <div>
                        <Row gutter={24}>
                            <Col span={12}>
                                <img className="uk-height-large uk-border-rounded" src="https://demo.hasthemes.com/safira-preview/safira/assets/img/blog/blog-big1.jpg" />
                            </Col>
                            <Col span={12}>
                                <div className="uk-height-large uk-flex uk-flex-middle">
                                    <div>
                                        <h2 className="uk-h2 uk-text-center uk-text-bolder uk-margin-small-bottom">
                                            Blog Image Post
                                        </h2>
                                        <p className="uk-h5 uk-text-center uk-margin-small-top uk-margin-remove-bottom">
                                            Aenean et tempor eros, vitae sollicitudin velit. Etiam varius enim nec quam tempor, sed efficitur ex ultrices. Phasellus pretium est vel dui vestibulum condimentum. Aenean nec suscipit nibh. Phasellus nec lacus id arcu facilisis elementum. Curabitur lobortis, elit ut elementum congue, erat ex bibendum odio, nec iaculis lacus sem non lorem. Duis suscipit metus ante, sed convallis quam posuere quis. Ut tincidunt eleifend odio, ac fringilla mi vehicula nec. Nunc vitae lacus eget lectus imperdiet tempus sed in dui. Nam molestie magna at risus consectetur, placerat suscipit justo dignissim. Sed vitae fringilla enim, nec ullamcorper arcu.

                                            Suspendisse turpis ipsum, tempus in nulla eu, posuere pharetra nibh. In dignissim vitae lorem non mollis. Praesent pretium tellus in tortor viverra condimentum. Nullam dignissim facilisis nisl, accumsan placerat justo ultricies vel. Vivamus finibus mi a neque pretium, ut convallis dui lacinia. Morbi a rutrum velit. Curabitur sagittis quam quis consectetur mattis. Aenean sit amet quam vel turpis interdum sagittis et eget neque. Nunc ante quam, luctus et neque a, interdum iaculis metus. Aliquam vel ante mattis, placerat orci id, vehicula quam. Suspendisse quis eros cursus, viverra urna sed, commodo mauris.
                                        </p>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </section>
                <section className="uk-background-default">
                    <div className="uk-padding uk-padding-remove-horizontal uk-container ">
                        <div className="uk-text-center">
                            <h3 className="uk-h2 uk-margin-small-bottom uk-text-bold">
                                Our team
                            </h3>
                        </div>
                        <div className="uk-margin-top">
                            <Row gutter={24} className="uk-grid-match">
                                <Col span={8}>
                                    <div className="uk-text-center">
                                        <div className="uk-padding-large uk-padding-remove-vertical">
                                            <img className="uk-height-small" src="https://demo.hasthemes.com/safira-preview/safira/assets/img/blog/blog1.jpg" />
                                        </div>
                                        <h5 className="uk-margin-top">
                                            SELECT THE DESIRED DATE
                                        </h5>
                                        <p>
                                            Lorem ipsum text of this redactor for new teamplate and exaple.
                                        </p>
                                    </div>
                                </Col>
                                <Col span={8}>
                                    <div className="uk-text-center">
                                        <div className="uk-padding-large uk-padding-remove-vertical">
                                            <img className="uk-height-small" src="https://demo.hasthemes.com/safira-preview/safira/assets/img/blog/blog2.jpg" />
                                        </div>
                                        <h5 className="uk-margin-top">
                                            SELECT THE DESIRED DATE
                                        </h5>
                                        <p>
                                            Lorem ipsum text of this redactor for new teamplate and exaple.
                                        </p>
                                    </div>
                                </Col>
                                <Col span={8}>
                                    <div className="uk-text-center">
                                        <div className="uk-padding-large uk-padding-remove-vertical">
                                            <img className="uk-height-small" src="https://demo.hasthemes.com/safira-preview/safira/assets/img/blog/blog3.jpg" />
                                        </div>
                                        <h5 className="uk-margin-top">
                                            SELECT THE DESIRED DATE
                                        </h5>
                                        <p>
                                            Lorem ipsum text of this redactor for new teamplate and exaple.
                                        </p>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </section>
                <section className="uk-background-default">
                    <div className="uk-padding uk-padding-remove-horizontal uk-container">
                        <div className="uk-text-center">
                            <h3 className="uk-h2 uk-margin-bottom uk-text-bold">
                                Our contacts
                            </h3>
                        </div>
                        <div className="uk-margin-top">
                            <Row gutter={32}>
                                <Col span={12}>
                                    <div className="uk-padding-remove-horizontal">
                                        <p className="uk-h4 uk-margin-remove-top uk-margin-bottom uk-container uk-container-small">
                                            If you have any further questions feel free to ask
                                        </p>
                                        <Form>
                                            <Form.Item
                                                name="username"
                                                rules={[{ required: true, message: 'Please input your username!' }]}
                                            >
                                                <Input placeholder="Enter your name" />
                                            </Form.Item>
                                            <Form.Item
                                                name="username"
                                                rules={[{ required: true, message: 'Please input your username!' }]}
                                            >
                                                <Input placeholder="Enter your phone" />
                                            </Form.Item>
                                            <Form.Item
                                                name="username"
                                                rules={[{ required: true, message: 'Please input your username!' }]}
                                            >
                                                <Input.TextArea rows={4} placeholder="You question" />
                                            </Form.Item>
                                            <Form.Item>
                                                <Button type="primary" htmlType="submit">
                                                    Send
                                                </Button>
                                            </Form.Item>
                                        </Form>
                                    </div>
                                </Col>
                                <Col span={12}>
                                    <div>
                                        <ul className="uk-list">
                                            <li>
                                                <a href="" className="uk-icon-button uk-margin-small-right" uk-icon="twitter"/> Twitter
                                            </li>
                                            <li>
                                                <a href="" className="uk-icon-button uk-margin-small-right" uk-icon="facebook"/> Facebook
                                            </li>
                                            <li>
                                                <a href="" className="uk-icon-button uk-margin-small-right" uk-icon="google-plus"/> Google
                                            </li>
                                            <li>
                                                <a href="" className="uk-icon-button uk-margin-small-right" uk-icon="twitter"/>  Telegram
                                            </li>
                                            <li>
                                                <a href="" className="uk-icon-button uk-margin-small-right" uk-icon="facebook"/> WhatsApp
                                            </li>
                                            <li>
                                                <a href="" className="uk-icon-button uk-margin-small-right" uk-icon="google-plus"/> Location
                                            </li>
                                        </ul>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

export default About;



// WEBPACK FOOTER //
// ./src/Components/Terms/About.js